export default {
      data() {
        return {
          // -1：title
        // 11：discountRatio
        // 14：(列表：title，门店：title、activitycontentresps)
        // 15：（列表固定文案，门店:storeCouponActivitys）
        // 18：ladderRules
        // 19：ladderRules
        // 20：firstOrderReductionAmount
        // 21：ladderRules
        // 23：title
        // 32：title
        // 41：title
        marketingTypeMap: {
            15: {
              type: '门店优惠券',
              handleFun: () => this.handleCoupon,
            },
            18: {
              type: '满减',
              handleFun:() => this.handleFullReduction,
            },
            21: {
              type: '满减',
              handleFun: () => this.handleFullReduction,
            },
            19: {
              type: '配送费',
              handleFun: () => this.handleDeliveryFee,
            },
            20: {
              type: '首单',
              handleFun: () => this.handleStoreFirst,
            },
            41: {
              type: 'sop活动',
              handleFun: () => this.handleDiscount,
            }
          },
          showCouponLabel: false,         
          promotionArr: []
        }
      },
      methods: {
          handlePromotionData(data) {
            try {
              this.promotionArr = []
              console.log('handlePromotionData',data)
              let {productPromotions=[],promotions=[],serviceLabel = ['']} = data

              productPromotions.forEach(pitem => {
                let originObj = {
                  titleStyle : 'background: #FC2040',
                  title: '',
                  msg: '',
                }
                originObj.title = this.$t('home.discountTitle')
                originObj.msg = pitem
                this.promotionArr.push(originObj)
              })
              promotions.forEach(item => {
                let matchActivity =  this.marketingTypeMap[item.marketingType] 
                if(matchActivity) {
                  matchActivity.handleFun()(item)
                }
              })
              this.handleServiceLabel(serviceLabel)
              console.log(this.promotionArr)

            }catch(err) {
              console.log('err',err)
            }
          },
          handleServiceLabel(serviceLabel) {
            if(serviceLabel.length) {
              serviceLabel.forEach(item => {
                let originObj = {
                  titleStyle : 'background: #FC2040',
                  title: '',
                  msg: '',
                }
                originObj.msg = item
                originObj.title = this.$t('home.MerchantService')
                this.promotionArr.push(originObj)
              })
            }
             
          },
          handleDeliveryFee(item) {
            let {ladderRules = []} = item
            let originObj = {
              titleStyle : 'background: #21C348;',
              title: this.$t('home.DeliveryFee'),
              msg: '',
            }
            if(ladderRules.length) {
              originObj.msg = this.$t('home.deducedeliveryfee')
            }else {
              originObj.msg = this.$t('home.FreeDelivery')
            }
            this.promotionArr.push(originObj)
          },
          // sop活动
          handleDiscount(item) {
            let {title = undefined} = item
            let originObj = {
              titleStyle : 'background: #FC2040',
              title: this.$t('home.discountTitle'),
              msg: title,
            }
            this.promotionArr.push(originObj)
          },
          // 可用优惠券
          handleCoupon(item) {
            let  {storeCouponActivitys={}} = item
            if(storeCouponActivitys.coupons && storeCouponActivitys.coupons.length) {
              let originObj = {
                type: 'special',
                titleStyle : '',
                title: this.$t('home.availablecoupons'),
                msg: this.$t('home.availablecoupons'),
              }
              this.showCouponLabel = true
              this.promotionArr.unshift(originObj)
            }else {
              this.showCouponLabel = false
            }
          },
          // 首单活动
          handleStoreFirst(item) {
            let {firstOrderReductionAmount={}} = item
            let str = this.getFirstOrderTitle(firstOrderReductionAmount.amount)
            let originObj = {
              titleStyle : 'background: #FFB800;',
              title: this.$t('home.storeFirstTitle'),
              msg: str,
            }
            this.promotionArr.push(originObj)
          },
          // 满减活动  - 门槛越低越靠前
          handleFullReduction(item) {
            let {ladderRules} = item
            let firstLadder = ladderRules[0];
            let newFullArr = []
            let min = firstLadder.thresholdAmt.amount
            let str = ''
            ladderRules.forEach(fitem => {
              let fullDesc = this.getFullReductionTitle(
                fitem.thresholdAmt.amount,
                fitem.discountAmt.amount
              );
              if(fitem.thresholdAmt.amount < min) {
                min = fitem.thresholdAmt.amount
                newFullArr.unshift(fullDesc)
              }else {
                newFullArr.push(fullDesc)
              }
            })
            str = newFullArr.join('、')
            let originObj = {
              titleStyle : 'background: #FC2040',
              title: this.$t('home.fullReductionTitle'),
              msg: str,
              simpleMsg: newFullArr[0]
            }
            this.promotionArr.push(originObj)
            console.log('满减处理后',str)
          },
          getFirstOrderTitle(count) {
              if (this.$root.lang === 'zh') {
                return `首单立减$${count}`
              }
              if (this.$root.lang === 'km') {
                return `ទទួលបាន${count}$ក្នុងការបញ្ជាទិញដំបូង`
              }
              return `$${count} Off 1st Order`
          },
          getFullReductionTitle(m, j) {
              if (this.$root.lang === 'zh') {
                return `满$${m}减$${j}`
              }
              if (this.$root.lang === 'km') {
                return `ទិញ$${m}បញ្ចុះតម្លៃ $${j}`
              }
              return `Buy $${m} Discount $${j}`
          },
      }
  }